var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17954",
    "data-name": "Group 17954",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.669,
    height: 54.649,
    viewBox: "0 0 54.669 54.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11893",
    "data-name": "Path 11893",
    d: "M2.632,35.875A1.708,1.708,0,0,1,.923,34.628,26.924,26.924,0,0,1,0,27.334a1.708,1.708,0,1,1,3.417,0,24.179,24.179,0,0,0,.855,6.375,1.708,1.708,0,0,1-1.641,2.167ZM27.334,0a27.06,27.06,0,0,0-20.5,9.31V8.542a1.708,1.708,0,0,0-3.417,0v5.125a1.708,1.708,0,0,0,1.708,1.708h5.125a1.708,1.708,0,1,0,0-3.417H9.072A23.626,23.626,0,0,1,27.334,3.417,23.917,23.917,0,0,1,51.251,27.334a1.708,1.708,0,1,0,3.417,0A27.334,27.334,0,0,0,27.334,0ZM49.543,39.292H44.418a1.708,1.708,0,1,0,0,3.417H45.6A23.917,23.917,0,0,1,6.612,39.292,1.714,1.714,0,0,0,3.639,41a27.334,27.334,0,0,0,44.195,4.356v.769a1.708,1.708,0,1,0,3.417,0V41A1.708,1.708,0,0,0,49.543,39.292Z",
    transform: "translate(0.001 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11894",
    "data-name": "Path 11894",
    d: "M23.083,40.167A17.083,17.083,0,1,1,40.167,23.083,17.083,17.083,0,0,1,23.083,40.167Zm0-30.75A13.667,13.667,0,1,0,36.75,23.083,13.667,13.667,0,0,0,23.083,9.417Z",
    transform: "translate(4.252 4.25)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11895",
    "data-name": "Path 11895",
    d: "M24.983,19.345a5.125,5.125,0,0,0-4.442-7.636,1.708,1.708,0,0,0-3.417,0H13.708a1.708,1.708,0,1,0,0,3.417v10.25a1.708,1.708,0,0,0,0,3.417h3.417a1.708,1.708,0,0,0,3.417,0H22.25a5.125,5.125,0,0,0,2.733-9.447ZM22.25,16.833a1.708,1.708,0,0,1-1.708,1.708H17.125V15.125h3.417A1.708,1.708,0,0,1,22.25,16.833Zm0,8.542H17.125V21.958H22.25a1.708,1.708,0,1,1,0,3.417Z",
    transform: "translate(8.502 7.084)",
    fill: "#d7df23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildCrypto);
export default __webpack_public_path__ + "static/media/buildCrypto.4f9fddc45038699dcecd92aba0a3e592.svg";
export { ForwardRef as ReactComponent };